package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class ChangePasswordRequest(
    val email: String,
    val password: String,
    val newPassword: String,
)

@Serializable
data class ChangeEmailRequest(
    val email: String,
    val userID: String,
    val organization: String
)

@Serializable
data class ChangePasswordResponse(
    val message: String? = null,
    val error: String? = null,
    val data: String? = null
)

//
@Serializable
data class ChangeEmailResponse(
    val error: String = "",
    val success: Boolean = false,
)
